import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const ocStepState = atom({
  key: "ocStepState",
  default: 1,
  effects_UNSTABLE: [ocPersistAtom],
});
